import type { BatchItem } from "containers/admin/clients/client/approval-queue/approval-queue.types";
import { NamedDictionaryItem } from "hooks/api/dictionary";
import { PaginatedRequestOptions } from "types/pagination";

export const ADD_TO_BATCH_LIST_PARAMS: PaginatedRequestOptions = {
  unpaged: true,
  sort: "lastModifiedDate,desc",
};

export const filterBatchesByStatus = (batches: BatchItem[]) =>
  batches.filter((batch) => batch.status === "IN_REVIEW" || batch.status === "BUILDING");

export const getBatchStatuses = (statuses: NamedDictionaryItem[], status: string) => {
  const statusConfig = statuses.find((s: NamedDictionaryItem) => s.name === status)!;

  return {
    status: status,
    clientReviewStatusName: statusConfig?.description,
    versionStatusName: status,
  };
};
